(function (angular) {
  "use strict";

  angular.module("Toyota.Factories").factory("RangeSorting", [
    "DebugLogger",
    function (DebugLogger) {
      function getSwatchOrderingComparator(presetSortOrder) {
        DebugLogger.log("RangeSorting", "getSwatchOrderingComparator(", presetSortOrder, ")");

        var presetSortOrderNormalised = presetSortOrder.map(function (value) {
          return value.toLowerCase();
        });

        return function (a, b) {
          var aValue = a.value.toLowerCase();
          var bValue = b.value.toLowerCase();

          var indexA = presetSortOrderNormalised.indexOf(aValue);
          var indexB = presetSortOrderNormalised.indexOf(bValue);

          if (indexA === -1 && indexB === -1) {
            return aValue < bValue ? -1 : 1;
          } else if (indexB === -1) {
            return -1;
          } else if (indexA === -1) {
            return 1;
          }

          return indexA < indexB ? -1 : 1;
        };
      }

      return {
        getSwatchOrderingComparator: getSwatchOrderingComparator,
      };
    },
  ]);
})(window.angular);
